/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Announcement,
} from '../models/index';
import {
    AnnouncementFromJSON,
    AnnouncementToJSON,
} from '../models/index';

/**
 * 
 */
export class AnnouncementResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getAnnouncementsOnDisplay without sending the request
     */
    async getAnnouncementsOnDisplayRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/announcement/on-display`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAnnouncementsOnDisplayRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Announcement>>> {
        const requestOptions = await this.getAnnouncementsOnDisplayRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AnnouncementFromJSON));
    }

    /**
     */
    async getAnnouncementsOnDisplay(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Announcement>> {
        const response = await this.getAnnouncementsOnDisplayRaw(initOverrides);
        return await response.value();
    }

}
